export default __webpack_public_path__ + "static/media/blob.0c3ee559.svg";